import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { filterActions } from './actions';
import { selectFilterChanged } from './selectors';

export const useFilterChange = () => {
  const dispatch = useDispatch();
  const store = useStore();

  const markFilterChanged = useCallback(() => {
    if (!selectFilterChanged(store.getState())) {
      dispatch(filterActions.setFilterChanged(true));
    }
  }, [dispatch, store]);

  const changeFilter = useCallback(
    (action) => {
      dispatch(action);
      markFilterChanged();
    },
    [dispatch, markFilterChanged]
  );

  return { changeFilter, markFilterChanged };
};
